import { motion } from "framer-motion";
import { scrollTo } from "./Navbar";

const MaskedLine = ({ children, delay, className }) => (
  <span className="block overflow-hidden">
    <motion.span
      className={`block ${className || ""}`}
      initial={{ y: "110%" }}
      animate={{ y: 0 }}
      transition={{ duration: 1.1, delay, ease: [0.16, 1, 0.3, 1] }}
    >
      {children}
    </motion.span>
  </span>
);

const Hero = () => (
  <header id="top" data-testid="hero-section" className="relative h-screen bg-[#0B1F3A] text-[#F7F2EC] noise-overlay overflow-hidden">
    <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_at_50%_35%,rgba(255,255,255,0.12),transparent_60%)]" />
    <div className="relative z-10 h-full px-4 sm:px-8 lg:px-16 max-w-7xl mx-auto flex flex-col items-center justify-center text-center">
      <h1 data-testid="hero-title" className="font-display leading-[0.82]">
        <MaskedLine delay={0.3} className="font-black text-[32vw] sm:text-[24vw] lg:text-[17rem] tracking-[-0.03em]">
          BANY
        </MaskedLine>
        <MaskedLine delay={0.5} className="font-medium text-sm sm:text-base lg:text-xl tracking-[0.7em] uppercase mt-3 text-[#F7F2EC]/90">
          Barbershop
        </MaskedLine>
      </h1>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 0.9, ease: [0.16, 1, 0.3, 1] }}
        className="mt-14 flex flex-wrap items-center justify-center gap-4"
      >
        <a
          href="#prenotazione"
          data-testid="hero-book-now-button"
          onClick={(e) => scrollTo(e, "#prenotazione")}
          className="rounded-full bg-[#F7F2EC] text-[#0B1F3A] px-8 py-4 text-sm font-bold uppercase tracking-[0.15em] hover:bg-white hover:shadow-[0_12px_40px_rgba(0,0,0,0.25)] hover:-translate-y-0.5 transition-all duration-300"
        >
          Prenota
        </a>
        <a
          href="#servizi"
          data-testid="hero-services-button"
          onClick={(e) => scrollTo(e, "#servizi")}
          className="rounded-full border border-[#F7F2EC]/50 text-[#F7F2EC] px-8 py-4 text-sm uppercase tracking-[0.15em] hover:border-[#F7F2EC] hover:bg-[#F7F2EC]/10 transition-all duration-300"
        >
          Listino
        </a>
      </motion.div>
    </div>

    <motion.p
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ delay: 1.6, duration: 1 }}
      data-testid="hero-address-badge"
      className="absolute bottom-8 left-0 right-0 text-center font-mono-alt text-[11px] uppercase tracking-[0.4em] text-[#F7F2EC]/60"
    >
      Novara · Corso Giuseppe Mazzini 25A
    </motion.p>
  </header>
);

export default Hero;
